"use client";

import { Screen } from "../_skins/registry";

/* 🔴 껍데기입니다 — 화면은 활성 스킨의 `register` (`_skins/registry.tsx`). */
export default function RegisterPage() {
  return <Screen name="register" />;
}
